import { Box } from '@mui/material';
import { IndicatorWithAlerts } from 'src/types/indicator-alert-configuration';

import { AlertTreeView } from './AlertTreeView';

type AlertFormProps = {
  indicatorsWithAlerts: IndicatorWithAlerts[];
  onAddAlert: (indicatorKey: string) => void;
  onUpdateAlert: (
    indicatorKey: string,
    internalId: string,
    field: string,
    value: any,
  ) => void;
  onRemoveAlert: (
    indicatorKey: string,
    internalId: string,
    id: number | null,
  ) => void;
};

export default function AlertForm({
  indicatorsWithAlerts,
  onAddAlert,
  onUpdateAlert,
  onRemoveAlert,
}: AlertFormProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <AlertTreeView
        indicatorsWithAlerts={indicatorsWithAlerts}
        onAddAlert={onAddAlert}
        onUpdateAlert={onUpdateAlert}
        onRemoveAlert={onRemoveAlert}
      />
    </Box>
  );
}
